import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {useAuthState} from "../../context/AuthContext";
import React, {useEffect, useState} from "react";
import {RouteHelper} from "../../route/RouteHelper";
import {Helmet} from "react-helmet";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import UserProfileDetailPage from "../../component/userProfileDetail/UserProfileDetailPage";
import ChangeUserName from "../../component/ChangeUserName/ChangeUserName";
import ChangePasswordCardComponent from "../../component/changePassword/ChangePasswordCardComponent";
import {ManagerAccessLevelTable} from "../../component/manangerDetail/ManagerAccessLevelTable";
import {ManagerBanAccess} from "../../component/manangerDetail/ManagerBanAccess";
import {useNavigate, useParams} from "react-router-dom";
import TabBoxContainer from "../../component/tabBoxContainer/TabBoxContainer";
import {ManagerService} from "../../serverService/managerManagement/ManagerService";
import {css} from "@emotion/css";
import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne, RaikoGridOneColumn, showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export const ManagerDetail = () => {

    const loading = useLoadingDispatcher()

    const {id: managerId = -1} = useParams()

    const service = new ManagerService()

    const [profileDetail, setProfileDetail] = useState({});
    const [adminName, setAdminName] = useState("جزئیات حساب");

    const [avatar, setAvatar] = useState("");

    useEffect(() => {
        if (profileDetail && profileDetail.firstName) {
            setAdminName(`${profileDetail.firstName} ${profileDetail.lastName}`)
        }
    }, [profileDetail])


    useEffect(() => {
        if (typeof service !== "undefined") {
            getDataFromServer()
        }
    }, [])


    function getDataFromServer() {
        loading(setLoadingStateDispatch(true))
        service.getProfileDetailById(managerId)
            .then(response => {
                setProfileDetail(response)
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading(setLoadingStateDispatch(false))
        })

        service.getManagerAvatar(managerId)
            .then(response => {
                setAvatar(response.downloadUrl)
            }).catch(reason => {

        })
    }


    const [value, setValue] = useState(ManagerTabTypes.ProfileContent.id);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function doChangePassword() {

    }

    const navigate = useNavigate()

    return (
        <>
            <Helmet>
                <title className="">{RouteHelper.Profile.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            breadCrumbItems={[
                                raikoBreadCrumbItemGenerator(
                                    "مدیریت",
                                    RouteHelper.ManagersList.globalUrl
                                ),
                                raikoBreadCrumbItemGenerator(
                                    RouteHelper.ManagersList.name,
                                    RouteHelper.ManagersList.globalUrl),
                                raikoBreadCrumbItemGenerator(
                                    adminName,
                                    ""),
                            ]}/>
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(RouteHelper.ManagersList.globalUrl)
                            }}/>
                    </RaikoFlexFirstChildGrowOne>


                    <TabContext value={value}>
                        <TabBoxContainer>
                            <TabList onChange={handleChange} id="default-tab-container" variant="scrollable">
                                <Tab icon={<div id="tabIcon" className={"ic-profile"}/>} iconPosition="start"
                                     label={ManagerTabTypes.ProfileContent.title}
                                     value={ManagerTabTypes.ProfileContent.id}/>

                                <Tab icon={<div id="tabIcon" className={"ic-access-level"}/>} iconPosition="start"
                                     label={ManagerTabTypes.AccessLevel.title}
                                     value={ManagerTabTypes.AccessLevel.id}/>

                                <Tab icon={<div id="tabIcon" className={"ic-key"}/>} iconPosition="start"
                                     label={ManagerTabTypes.ChangeUsername.title}
                                     value={ManagerTabTypes.ChangeUsername.id}/>

                                <Tab icon={<div id="tabIcon" className={"ic-security"}/>} iconPosition="start"
                                     label={ManagerTabTypes.Password.title}
                                     value={ManagerTabTypes.Password.id}/>

                                <Tab icon={<div id="tabIcon" className={"ic-ban-access-level"}/>} iconPosition="start"
                                     label={ManagerTabTypes.BanAccess.title}
                                     value={ManagerTabTypes.BanAccess.id}/>

                            </TabList>
                        </TabBoxContainer>
                        <TabPanel value={ManagerTabTypes.ProfileContent.id}>
                            <UserProfileDetailPage
                                adminId={managerId}
                                profileDetail={profileDetail}
                                setProfileDetail={setProfileDetail}
                                service={service}
                                avatarFile={avatar}
                                setAvatarFile={setAvatar}
                            />
                        </TabPanel>
                        <TabPanel value={ManagerTabTypes.AccessLevel.id}>
                            <ManagerAccessLevelTable managerId={managerId} service={service}/>
                        </TabPanel>
                        <TabPanel value={ManagerTabTypes.ChangeUsername.id}>
                            <ChangeUserName
                                service={service}
                                hint={"بعد از تغییر نام کاربری، مدیر مربوطه می بایست مجددا با نام کاربری جدید وارد سامانه شود ."}
                                adminId={managerId}
                                refreshDetailInfo={_ => {
                                    getDataFromServer()
                                }}
                            />
                        </TabPanel>
                        <TabPanel value={ManagerTabTypes.Password.id}>
                            <ChangePasswordCardComponent
                                adminId={managerId}
                                service={service}
                                doChangePassword={doChangePassword}
                            />
                        </TabPanel>
                        <TabPanel value={ManagerTabTypes.BanAccess.id}>
                            <ManagerBanAccess
                                managerId={managerId}
                                service={service}
                            />
                        </TabPanel>
                    </TabContext>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>


    )
}

const ManagerTabTypes = {
    ProfileContent: {
        id: "profile-content",
        title: "جزئیات حساب"
    }, AccessLevel: {
        id: "access-level",
        title: "سطح دسترسی"
    }, ChangeUsername: {
        id: "change-username",
        title: "نام کاربری"
    },
    Password: {
        id: "password",
        title: "رمز عبور"
    },
    BanAccess: {
        id: "ban-access",
        title: "مسدود سازی"
    },
}